<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="deliveryForm"
              :model="delivery"
              class="box"
              label-width="100px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('delivery.serialNo')">
                      {{ delivery.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('delivery.deliveryType')">
                      <span v-if="delivery.deliverType != null">
                        {{ $t("deliverTypes." + delivery.deliverType) }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('delivery.deliverAt')">
                      {{ delivery.deliverAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8" v-if="delivery.attachment != null">
                    <el-form-item :label="$t('product.attachment')">
                      <thumbnail-text
                        v-if="delivery.attachment != null"
                        :srcs="delivery.attachment"
                        :text="$t('product.attachment')"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("delivery.deliverInfo") }}
                  <span class="mgl20" v-if="delivery.tracking != null">
                    {{ $t("delivery.tracking") }}: {{ delivery.tracking }}
                  </span>
                </legend>
                <span v-if="delivery.deliverType == 'agent'">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('menu.couriers')">
                        {{ delivery.courierName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('delivery.deliveryMethode')">
                        {{ delivery.deliverMethodName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('delivery.insured')">
                        {{ delivery.insured | currency }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('delivery.weight')">
                        {{ delivery.weight }}
                        <span v-if="delivery.weight != null">kg</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('delivery.courierWeight')">
                        {{ delivery.courierWeight }}
                        <span v-if="delivery.courierWeight != null">kg</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('shop.iossNum')">
                        {{ delivery.iossNum }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('shop.iossCountryCode')">
                        {{ delivery.iossCountryCode }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="delivery.aliexpressShipAt != null">
                      <el-form-item :label="$t('delivery.aliexpressShipAt')">
                        {{ delivery.aliexpressShipAt }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </span>
                <el-row v-if="delivery.deliverType == 'express'">
                  <el-col :span="6">
                    <el-form-item :label="$t('delivery.express')">
                      {{ delivery.express }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('delivery.deliverCost')">
                      {{ delivery.deliverCost | currency }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="delivery.deliverType == 'carry'">
                  <el-col :span="6">
                    <el-form-item :label="$t('delivery.sender')">
                      {{ delivery.sender }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('delivery.deliverCost')">
                      {{ delivery.deliverCost | currency }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("customer.customerInfo") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('bargain.customerName')">
                      {{ delivery.customerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('bargain.customerPhone')">
                      {{ delivery.customerPhone }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.country')">
                      <span v-if="delivery.customerCountry != null">{{
                        $t("countries." + delivery.customerCountry)
                      }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.province')">
                      {{ delivery.customerProvince }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.city')">
                      {{ delivery.customerCity }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('customer.zipcode')">
                      {{ delivery.customerZipcode }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :label="$t('tenant.address')">
                      {{ delivery.customerAddress }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="delivery.remark"></raw-html>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Currency from "@/components/Currency";
import ThumbnailText from "@/components/ThumbnailText";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";
import Delivery from "@/api/delivery.js";
import Log from "@/api/log.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Currency,
    ThumbnailText,
    RawHtml,
    Dropzone,
  },
  data() {
    return {
      activeName: "detail",
      delivery: {},
      logs: [],
      loadind: false,
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getDelivery();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },
    getDelivery() {
      const self = this;
      self.loadingStart();
      self.loadind = true;
      Delivery.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.delivery = res.data.entity;
          self.loadind = false;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getLogs() {
      const self = this;
      Log.forEntity("Delivery", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
  },
};
</script>